module.exports = __webpack_public_path__ + "dash_20_app_assets/img/logo.adf1b566.png";